import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddUserLayer } from "../components/Gamesuser/AddUserLayer";



const AddUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

<AddUserLayer />


      </MasterLayout>
    </>
  );
};

export default AddUserPage;
